var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.name)}}),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.skill)}})]),_c('main',[_c('Profile'),_c('Experience')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }